//hook
import { useState, useEffect } from 'react';
import { useApi } from '../../hooks/useApi';

//mui
import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogProps, 
    DialogTitle, 
    FormControl, 
    IconButton, 
    InputLabel, 
    MenuItem, 
    OutlinedInput, 
    Select, 
    Slide, 
    TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

//mui icon
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { TransitionProps } from '@mui/material/transitions';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ReplayIcon from '@mui/icons-material/Replay';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';


//type
import { MyCarType } from '../../api/Host/type/AddCarType';
import { AddOfferReqType, offerType } from '../../api/offers/type/OfferType'

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

//api
import { GetListOffersOFCar } from '../../api/offers/GetListOffersOFCar';
import { UpdateOfferCarApi } from '../../api/offers/UpdateOfferCarApi';
import { PostAddOfferApi } from '../../api/offers/PostAddOfferApi';

//component
import NoData from '../../component/NoData';
import OfferCard from '../../component/offer/OfferCard';


//image
import offerPlaceHolder from "../../assets/offerPlaceHolder.png"

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//DateTimePicker
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

//moment
import moment from 'moment';
import DeleteConfirmation from '../DeleteConfirmation';
import { DeleteOfferApi } from '../../api/offers/DeleteOfferApi';


interface offerListProps {
    showCarOffers: {open:boolean,scrollType: DialogProps['scroll']},
    setShowCarOffers: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void,
    setSelectedCar: (selectedCar?: MyCarType) => void
    selectedCar?: MyCarType
}

const status = ["active", "disabled"];
const periodUnit = ["day", "week", "month", "year"];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OfferList = ({showCarOffers, setShowCarOffers, setSelectedCar, selectedCar}: offerListProps) => {
    const {t} = useTranslation()
    const [addAndUpdateOffer, setAddAndUpdateOffer] = useState<string>("")
    let [offerData, setOfferData] = useState<offerType[]>([])
    let [selectedOffer, setSelectedOffer] = useState<offerType | null>(null)
    let [openDeleteConfirmation, setOpenDeleteConfirmation] = useState<boolean>(false);
    const offerSchema = Yup.object().shape({
        status: Yup.string().required(t("please_select_a_status")),
        start_date: Yup.mixed()
            .required(t("start_date_is_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "YYYY-MM-DD HH:mm:ss").isValid()),
        end_date: Yup.mixed()
            .required(t("end_date_is_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "YYYY-MM-DD HH:mm:ss").isValid()
            ),
        period_unit: Yup.string().required(t("please_select_a_period_unit")),
        period_count: Yup.number()
        .required(t("period_count_required"))
        .test("period_count_required", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        price: Yup.number()
        .required(t("price_required"))
        .test("price_required", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
    })
    const {
        loading: offersCarLoaing,
        error: offersCarError,
        HandlerApi: getOffersCar
    } = useApi(GetListOffersOFCar, "GET")
    const {
        loading: addOfferCarLoaing,
        error: addOfferCarError,
        HandlerApi: addOfferCarApi
    } = useApi(PostAddOfferApi, "GET")
    const {
        loading: updateOfferCarLoaing,
        error: updateOfferCarError,
        HandlerApi: updateOfferCarApi
    } = useApi(UpdateOfferCarApi, "GET")
    const {
        loading: deleteOfferCarLoaing,
        error: deleteOfferCarError,
        HandlerApi: deleteOfferCarApi
    } = useApi(DeleteOfferApi, "DELETE")
   useEffect(() => {
    const fetchData = async () => {
      let result = await getOffersCar(selectedCar?.id);
      setOfferData(result.data);
    }
    fetchData();
   },[])

   //start functions

   const handleSubmit = async (values: AddOfferReqType) => {
        let result
        if(addAndUpdateOffer === "add") {
            result = await addOfferCarApi(values);
        }
        else {
            result = await updateOfferCarApi(values, selectedOffer?.id);
        }
        if(result?.data) {
            setShowCarOffers({open: false, scrollType: "paper"});
            setSelectedCar?.(undefined)
            setAddAndUpdateOffer("")
            setSelectedOffer(null)
        }
   }

   //start functions
   
    return (
        <Dialog 
        open={showCarOffers.open}
        onClose={()=>{
            setShowCarOffers({open: false, scrollType: "paper"});
            setSelectedCar?.(undefined)
            setAddAndUpdateOffer("")
            setSelectedOffer(null)
        }}
        slots={{
        transition: Transition,
        }}
        disableRestoreFocus
        maxWidth="sm"
        fullWidth 
        >
            <div className="pt-4 sm:px-6 max-sm:px-2 pb-0">
                {
                    addAndUpdateOffer === ""
                    ?
                        <>
                            <div className='flex w-full justify-between'>
                                <IconButton
                                className={`${selectedCar?.fuel_type === "electric" ? "!bg-electricColor" : " !bg-paretnerColor"} !rounded-md max-sm:!w-[30px] max-sm:!h-[30px]`}
                                onClick={() => {
                                    setShowCarOffers({open: false, scrollType: "paper"});
                                    setSelectedCar?.(undefined)
                                    setAddAndUpdateOffer("")
                                    setSelectedOffer(null)
                                }}
                                size="large"
                                >
                                    <CloseIcon className='!text-white'/>
                                </IconButton>
                                <div 
                                onClick={()=>{setAddAndUpdateOffer("add"); setSelectedOffer(null)}}
                                className={`w-fit cursor-pointer flex justify-between items-center gap-2 p-2 text-[12px] rounded-lg text-white ${selectedCar?.fuel_type === "electric" ? "!bg-electricColor" : " !bg-paretnerColor"}`}>
                                    <p> 
                                        <ControlPointIcon/>
                                    </p>
                                    <p>{t("add_new_offer")}</p>
                                </div>
                            </div>
                            <div className='mt-5'>
                                {
                                    offersCarLoaing
                                    ?
                                        <div className='flex justify-center'>
                                            <CircularProgress/>
                                        </div>
                                    : offersCarError
                                        ?
                                        <div className='cursor-pointer flex justify-center'>
                                            <ReplayIcon onClick={()=>{getOffersCar(selectedCar?.id)}} className='!text-[40px]'/>
                                        </div>
                                        :
                                            offerData.length === 0
                                            ? <NoData width={"150px"} title={t("offers")} description={t("you_don't_have_any_offers_yet")} image={offerPlaceHolder}/>
                                            :
                                            <div className='h-[600px]'>
                                                {
                                                    offerData.map((element: any, index: number) => (
                                                        <div key={index}>
                                                            <OfferCard 
                                                            element={element}
                                                            selectedCar={selectedCar}
                                                            setAddAndUpdateOffer={setAddAndUpdateOffer}
                                                            setSelectedOffer={setSelectedOffer}
                                                            setOpenDeleteConfirmation={setOpenDeleteConfirmation}
                                                            />
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                }
                            </div>
                        </>
                    :
                        <>
                            <DialogTitle className='!p-0 !flex !justify-between'>
                                <div>
                                    {
                                        addAndUpdateOffer === "edit"
                                        ?<p>{t("edit_offer") }</p>
                                        :<p>{t(`add_offer`)}</p>
                                    }
                                </div>
                                <div className="flex items-center gap-2 mb-3 cursor-pointer" onClick={() => {setAddAndUpdateOffer(""); setSelectedOffer(null)}}>
                                    <p>{i18n.language === "en" ? <ArrowBackOutlinedIcon /> : <ArrowForwardIcon />}</p>
                                    <p className='text-sm'>{t("back")}</p>
                                </div>
                            </DialogTitle>
                            <div>
                                <Formik
                                enableReinitialize
                                initialValues={{
                                    car_id: selectedCar?.id,
                                    status: selectedOffer?.status || "",
                                    start_date: selectedOffer?.start_date || null,
                                    end_date: selectedOffer?.end_date || null,
                                    period_unit: selectedOffer?.period_unit || "",
                                    period_count: selectedOffer?.period_count || "",
                                    price: selectedOffer?.price || ""
                                }}
                                validationSchema={offerSchema}
                                onSubmit={(values)=>handleSubmit(values)}
                                >
                                {({values,touched, errors,setFieldValue, setFieldTouched}) => (
                                    <Form>
                                        <div className='flex max-sm:flex-col gap-2 mb-3'>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DateTimePicker
                                                label={t("start_date")}
                                                format="YYYY-MM-DD HH:mm:ss"
                                                minDateTime={moment()}    
                                                closeOnSelect={false}
                                                value={values.start_date ? moment(values.start_date, "YYYY-MM-DD HH:mm:ss") : null}
                                                onChange={(value) => {
                                                    setFieldValue("start_date", value ? value.format("YYYY-MM-DD HH:mm:ss") : null);
                                                }}
                                                onClose={() => {
                                                    setFieldTouched("start_date", true);
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        helperText: values.start_date === null && touched.start_date && errors.start_date ? errors.start_date : null,
                                                        error: values.start_date === null && touched.start_date && Boolean(errors.start_date),
                                                        className: "w-full"
                                                    }
                                                }}
                                                />
                                            </LocalizationProvider>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DateTimePicker
                                                label={t("end_date")}
                                                format="YYYY-MM-DD HH:mm:ss"
                                                minDateTime={moment()}    
                                                closeOnSelect={false}
                                                value={values.end_date ? moment(values.end_date, "YYYY-MM-DD HH:mm:ss") : null}
                                                onChange={(value) => {
                                                    setFieldValue("end_date", value ? value.format("YYYY-MM-DD HH:mm:ss") : null);
                                                }}
                                                onClose={() => {
                                                    setFieldTouched("end_date", true);
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        helperText: values.end_date === null && touched.end_date && errors.end_date ? errors.end_date : null,
                                                        error: values.end_date === null && touched.end_date && Boolean(errors.end_date),
                                                        className: "w-full"
                                                    }
                                                }}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        <div className='flex max-sm:flex-col gap-2 mb-3'>
                                            <FormControl className='sm:!w-1/2 !w-full' error={touched.status && Boolean(errors.status)}>
                                                <InputLabel>{t("status")}</InputLabel>
                                                <Select
                                                input={<OutlinedInput label={t("status")} />}
                                                MenuProps={MenuProps}
                                                value={values.status || ""}
                                                onChange={(e) => setFieldValue("status",e.target.value)}
                                                >
                                                    {status.map((item: any, index: number) => (
                                                        <MenuItem key={index} value={item}>{t(item)}</MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.status && errors.status && (
                                                    <p className="text-red-500 text-xs mt-1">
                                                    {errors.status as string}
                                                    </p>
                                                )}
                                            </FormControl>
                                            <FormControl className='sm:!w-1/2 !w-full' error={touched.status && Boolean(errors.status)}>
                                                <InputLabel>{t("period_unit")}</InputLabel>
                                                <Select
                                                input={<OutlinedInput label={t("period_unit")} />}
                                                MenuProps={MenuProps}
                                                value={values.period_unit || ""}
                                                onChange={(e) => setFieldValue("period_unit",e.target.value)}
                                                >
                                                    {periodUnit.map((item: any, index: number) => (
                                                        <MenuItem key={index} value={item}>{t(item)}</MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.period_unit && errors.period_unit && (
                                                    <p className="text-red-500 text-xs mt-1">
                                                    {errors.period_unit as string}
                                                    </p>
                                                )}
                                            </FormControl>
                                        </div>
                                        <div className='flex max-sm:flex-col gap-2 mb-3'>
                                            <Field
                                                as={TextField}
                                                type="number"
                                                name="period_count"
                                                label={t("period_count")}
                                                className="sm:w-1/2 w-full !mb-2"
                                                helperText={touched.period_count && errors.period_count ? errors.period_count : ""}
                                                error={touched.period_count && Boolean(errors.period_count)}
                                            />
                                            <Field
                                                as={TextField}
                                                type="number"
                                                name="price"
                                                label={t("price")}
                                                className="sm:w-1/2 w-full !mb-2"
                                                helperText={touched.price && errors.price ? errors.price : ""}
                                                error={touched.price && Boolean(errors.price)}
                                            />
                                        </div>
                                        <hr className='m-5'/>
                                        <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                                            <Button className='w-full !bg-paretnerColor !text-white !rounded-full' type="submit">
                                                {addOfferCarLoaing || updateOfferCarLoaing
                                                ? <CircularProgress className='w-1 h-1'/>
                                                :addAndUpdateOffer === "edit" ? t("update_offer") :t("confirm")
                                                }
                                            </Button>
                                        </DialogActions>
                                    </Form>
                                )}
                                </Formik>
                            </div>
                        </>
                }
            </div>
            <DeleteConfirmation
            openDeleteConfirmation={openDeleteConfirmation} 
            setOpenDeleteConfirmation={setOpenDeleteConfirmation}
            id={selectedOffer?.id}
            deleteFunction={deleteOfferCarApi}
            deleteLoading={deleteOfferCarLoaing}
            recallFunction={getOffersCar}
            setData={setOfferData}
            />
        </Dialog>
    )
}

export default OfferList